/**
 * editor_plugin_src.js
 *
 * Copyright 2009, Moxiecode Systems AB
 * Released under LGPL License.
 *
 * License: http://tinymce.moxiecode.com/license
 * Contributing: http://tinymce.moxiecode.com/contributing
 */

import window from 'window-or-global';

export default function emotions() {
	const plugger = () => {
		return {
			init(ed, url) {
				// Register commands
				ed.addCommand('mceEmotion', () => {
					ed.windowManager.open(
						{
							file: `${window.tinymce.settings.editor_plugin_action_base_path}/emotions.action`,
							width: 190 + parseInt(ed.getLang('emotions.delta_width', 0)),
							height: 125 + parseInt(ed.getLang('emotions.delta_height', 0)),
							inline: 1,
							id: 'insert-emoticon-dialog',
							name: 'emotions_dlg.title',
						},
						{
							plugin_url: url,
						},
					);
				});

				// Register buttons
				ed.addButton('emotions', {
					title: 'emotions.emotions_desc',
					cmd: 'mceEmotion',
				});

				// CONFDEV-2652 - Deal with click of emoticons - reposition cursor to the left or right depending on where
				// the users clicked on the emoticon
				ed.on('Click', (e) => {
					const n = e.target;
					let rng;
					if (n.nodeName === 'IMG') {
						if (n.classList.contains('emoticon')) {
							rng = ed.selection.getRng(true);
							const clickOffsetX = e.offsetX || e.layerX - n.x;
							const width = n.width;
							if (clickOffsetX < width / 2) {
								// Click on left side - move cursor before
								rng.setStartBefore(n);
								rng.setEndBefore(n);
							} else {
								// Click on left side - move cursor after
								rng.setStartAfter(n);
								rng.setEndAfter(n);
							}
							ed.selection.setRng(rng);
							ed.selection.collapse();

							return window.tinymce.dom.Event.cancel(e);
						}
					}
				});
			},

			getInfo() {
				return {
					longname: 'Emotions',
					author: 'Moxiecode Systems AB',
					authorurl: 'http://tinymce.moxiecode.com',
					infourl: 'http://wiki.moxiecode.com/index.php/TinyMCE:Plugins/emotions',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.EmotionsPlugin', plugger());
	window.tinymce.PluginManager.add('emotions', window.tinymce.plugins.EmotionsPlugin);
}
